export default {
  index: {
    tencentCompanyEdition: '腾讯公司 版权所有',
  },
};
